module.exports = __webpack_public_path__ + "static/media/calendar.f8c5ba39.svg";